export function converJsonToCsv(jsonArray) {
  const replacer = (key, value) => value === null ? '' : value;
  const header = Object.keys(jsonArray[0]);
  let csv = jsonArray.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','));
  csv.unshift(header.join(','));
  csv = csv.join('\r\n');
  return csv;
}


// WEBPACK FOOTER //
// ./src/shared/dataConversion.js